import { useState, useEffect } from "react";
import Image from "../images/Image";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import useTranslation from "../CustomHooks/useTranslation";
import { inputFieldContent } from "./InputFieldContent";

interface InputFieldwithSearchProps {
  handleSearchValue: (value: string) => void;
  testId: string;
  searchValue?: string | null;
  disabled?: boolean;
  placeHolder?: string;
  className?: string;
  disableSearchAndFilter?: boolean;
  placeholderClassName?: string;
}

export default function InputFieldwithSearch({
  handleSearchValue,
  testId,
  searchValue,
  disabled,
  placeHolder,
  className,
  placeholderClassName,
}: InputFieldwithSearchProps) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { notEnglish } = useTranslation(inputFieldContent);
  const [searchTerm, setSearchTerm] = useState(searchValue ? searchValue : "");
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  useEffect(() => {
    if (searchValue !== undefined && searchValue !== null) {
      setSearchTerm(searchValue);
    }
  }, [searchValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (value.trim().length !== 0 || searchTerm.length !== 0) {
      setSearchTerm(value.startsWith(" ") ? value.trim() : value.replaceAll('  ', ' ')); // Set the search term to the input value
      // Clear previous debounce timeout if any
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      // Set a new timeout to handle debounce logic (500ms delay)
      const timeout = setTimeout(() => {
        handleSearchValue(value.trim().replaceAll('  ', ' ')); // Call the parent component after debounce with trimmed value
      }, 500);

      setDebounceTimeout(timeout);
    }
  };
  const handleOnClose = () => {
    setSearchTerm("");
    handleSearchValue(""); // Notify the parent component that the search term has been cleared
  };

  return (
    <div
      className={` ${className && className}  ${
        disabled
          ? "border-disable_stroke bg-disable_fill"
          : "border-P_light_active"
      } h-10 border rounded-lg flex items-center justify-between focus-within:border-2 ${
        notEnglish
          ? "pr-2.5 focus-within:pr-[9px]"
          : "pl-2.5 focus-within:pl-[9px]"
      } gap-2`}
      dir={notEnglish ? "rtl" : "ltr"}
    >
      <Image src={disabled ? "search" : "active_search"} className="w-5 h-5" />
      <input
        id="search-input"
        className={`text-body2 disabled:cursor-not-allowed w-full outline-hidden bg-transparent grow ${
          !searchTerm ? placeholderClassName : ""
        }`}
        placeholder={placeHolder || "Search"}
        value={searchTerm}
        disabled={disabled}
        onChange={handleOnChange}
        autoComplete="off"
        maxLength={100}
        data-testid={testId}
      />
      {searchTerm.length !== 0 && (
        <div className="pl-2">
          <Image
            src="close"
            onClick={disabled ? () => {} : handleOnClose}
            className="cursor-pointer w-5 h-5 mr-[15px] my-2.5 "
            testId="clear-search"
          />
        </div>
      )}
    </div>
  );
}
